import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'mar-graph-container',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `<ng-content />`,
	host: {
		class: 'overflow-hidden flex flex-col border-2 border-primary shadow-md w-full min-h-96 bg-white rounded-lg',
	},
})
export class GraphContainerComponent {}
